/* eslint-disable no-unused-vars */
import styled from "styled-components";
import { Section } from "../../styles/commonStyles";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import CustomImage from "../Image";

const CLOUDINARY_BASE_URL = "/cloudinary";

const FeaturedInLogos = () => (
	<MainSection>
		<SectionHeading>
			<HeadingWord>Featured in</HeadingWord>
		</SectionHeading>
		<LogosContainer>
			<LogosWrapper>
				<Logos>
					<a
						href="https://timesofindia.indiatimes.com/city/ranchi/ranchi-admin-to-launch-job-hunt-app-this-mnth/articleshow/78667863.cms?from=mdr"
						id="featured-in-TOI-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/toi-logo_axgdtg.jpg`}
							alt="TOI Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.jagran.com/jharkhand/ranchi-job-opportunities-ranchi-district-administration-signed-mou-with-apna-time-tech-private-limited-for-employment-20871242.html"
						id="featured-in-jagaran-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/jagran-logo_jhbnmk.jpg`}
							alt="Jagaran Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://techcrunch.com/2021/03/01/apple-alum-jobs-app-apna-for-india-workers-raises-12-5-million/"
						id="featured-in-tech-crunch-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/TechCrunch-logo_qfszwu.png`}
							alt="TechCrunch Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.livemint.com/companies/start-ups/apna-co-raises-8-million-from-lightspeed-india-sequoia-11598941898228.html"
						id="featured-in-livemint-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/mint-logo.svg`}
							alt="Mint Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://yourstory.com/2021/03/funding-alert-apnaco-raises-additional-125-m-investment-existing-investors-startup"
						id="featured-in-your-story-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/yourstory-logo.svg`}
							alt="Your story Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://economictimes.indiatimes.com/tech/funding/apna-co-raises-12-5-million-led-by-sequoia-greenoaks/articleshow/81285328.cms"
						id="featured-in-ET-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/economic-times-logo_ojmlhj.jpg`}
							alt="Economic times Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.google.com/amp/s/www.bloomberg.com/amp/news/articles/2020-08-31/jobs-app-for-poor-indian-workers-gets-8-million-from-investors"
						id="featured-in-bloomberg-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Bloomberg-logo_v9vksm.jpg`}
							alt="Bloomberg Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.ndtv.com/business/apna-jobs-app-for-poor-workers-used-by-amazon-bigbasket-raises-8-million-from-greenoaks-capital-rocketship-vc-2288385"
						id="featured-in-NDTV-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/ndtv-logo_cvlstl.png`}
							alt="NDTV Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.vccircle.com/sequoia-lightspeed-lead-series-a-funding-for-recruitment-platform-apna-co"
						id="featured-in-vcc-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/VCC-logo.svg`}
							alt="VC Circle Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://economictimes.indiatimes.com/startups/apna-raises-8-million-series-a-funding-from-lightspeed-india-sequoia-others/articleshow/77862152.cms"
						id="featured-in-ET-tech-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/ettech-logo_gantle.jpg`}
							alt="ETtech Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.dealstreetasia.com/stories/apna-co-lightspeed-sequoia-204580/"
						id="featured-in-Deal-Street-Asia-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/DealStreetAsia-logo_psblki.png`}
							alt="Deal street asia Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.thehindubusinessline.com/info-tech/jobs-app-for-blue-grey-collar-workers-raises-8-million-funding/article32493174.ece"
						id="featured-in-Business-Line-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Business-Line-logo_tzk4hb.jpg`}
							alt="Business Line Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.financialexpress.com/industry/sme/linkedin-like-jobs-app-for-poor-indian-workers-secures-8-million-from-investors-apna-startup/2071170/"
						id="featured-in-FE-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/FE-logo_zi4dzs.png`}
							alt="FE Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.business-standard.com/article/companies/desi-professional-network-startup-apna-raises-8-mn-in-series-a-funding-120090100678_1.html"
						id="featured-in-Business-Standard-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Business-Standard_vq3lvp.jpg`}
							alt="Business Standard Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://appleinsider.com/articles/20/08/14/ex-apple-employee-helps-indias-unemployed-with-a-new-android-jobs-app"
						id="featured-in-business-insider-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Business-Insider-logo_q8ddky.png`}
							alt="Business Insider Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="http://bwdisrupt.businessworld.in/article/Apna-co-raises-8-million-in-series-A-funding-from-existing-investors-and-participation-from-Greenoaks-Capital-and-Rocketship-VC/01-09-2020-315280/"
						id="featured-in-business-world-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Business-World-logo_q8idti.jpg`}
							alt="Business World Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://timesnext.com/apna-co-bags-8-million-usd-from-lightspeed-and-sequoia/"
						id="featured-in-times-next-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/timesnext-logo_dudx8r.jpg`}
							alt="Times Next Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://theprint.in/economy/apna-linkedin-for-poor-indian-workers-who-dont-know-english-gets-8-million-investment/493134/"
						id="featured-in-the-print-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/the-print-logo_okoray.jpg`}
							alt="The Print Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.techcircle.in/2020/09/01/jobtech-startup-apna-co-raises-8-mn-in-series-a-round"
						id="featured-in-tech-circle-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/tech-circle-logo_qy3pbg.jpg`}
							alt="Tech Circle Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.bloombergquint.com/businessweek/apna-job-app-aims-to-connect-india-s-workers-with-employees"
						id="featured-in-bloomberg-quint-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/bb-quint-logo_xr31jm.jpg`}
							alt="Bloomberg Quint Logo"
						/>
					</a>
				</Logos>
				<Logos>
					<a
						href="https://www.moneycontrol.com/news/business/startup/apple-alumnis-app-for-indian-job-seekers-employers-raises-8-million-in-funding-report-5784371.html"
						id="featured-in-Money-Control-article-link"
						rel="noopener noreferrer"
						target="_blank"
					>
						<LogoImage
							width={100}
							height={100}
							src={`${CLOUDINARY_BASE_URL}/Moneycontrol-Logo_h56n9f.jpg`}
							alt="Money Control Logo"
						/>
					</a>
				</Logos>
			</LogosWrapper>
		</LogosContainer>
	</MainSection>
);
// Styles
const MainSection = styled(Section)`
	z-index: 3;
	position: relative;
	border-top: 1px solid rgba(77, 57, 81, 0.2);
	background-color: #f8f8f8;
	padding: 70px 16px 50px;
	max-width: 100%;
	margin: 0 auto;

	${mediaMaxWidth.medium`
		max-width: 100%;
		padding: 40px 15px 0 !important;
	`}
`;
const SectionHeading = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	& .hide-heading-desktop-view {
		display: none;
	}
	${mediaMaxWidth.medium`
		& .hide-heading-desktop-view {
			display: block;
		}
		& .hide-heading-mobile-view {
			display: none;
		}
	`}
`;
const HeadingWord = styled.h2`
	font-weight: 900;
	font-size: 32px;
	line-height: 1.38;
	text-align: center;
	color: #373737;
	margin-bottom: 5px;

	${mediaMaxWidth.medium`
        font-size: 19px;
        line-height: normal;
    `}
`;
const LogosContainer = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	overflow-y: hidden;
	overflow-x: scroll;
	&::-webkit-scrollbar {
		display: none;
	}
`;
const LogosWrapper = styled.div`
	display: inline-flex;
`;
const Logos = styled.div`
	object-fit: contain;
	width: 100%;
	min-width: 160px;
	min-height: 160px;
	margin: 15px 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border: 1px solid rgb(221, 221, 221);
	border-radius: 8px;
	box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);

	& svg {
		width: 100%;
		height: auto;
	}
	${mediaMaxWidth.medium`
		min-width: 80px;
		min-height: 80px;
		padding: 0 10px !important;
	`}
`;
const LogoImage = styled(CustomImage)`
	object-fit: contain;
`;

export default FeaturedInLogos;
